export default __webpack_public_path__ + "static/media/course-icon.a6bba4f0.svg";